import React, { useCallback } from 'react';

import { twMerge } from 'tailwind-merge';

import Dialog from 'components/dialog/dialog';

import Typography from 'components/typography/typography';

import Icon from 'components/icon/icon';

import Divider from 'components/divider/divider';

import Button from 'components/button/button';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');

interface ConfirmationDialogProps {
  message?: string;
  isOpen?: boolean;
  isLoading?: boolean;
  onCloseClicked: () => void;
  onConfirm?: () => void;
}
const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (props) => {
  const { message, isOpen, isLoading, onCloseClicked, onConfirm } = props;

  const closeButtonClassNames = twMerge(
    'absolute right-3 p-2 rounded-md',
    'hover:bg-gray100',
    'transition ease-in-out duration-300',
  );

  const onConfirmClicked = useCallback(() => {
    onConfirm?.();
  }, [onConfirm]);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCloseClicked}
      className="max-w-[95%] max-h-[90%] lg:max-w-[640px]"
    >
      <div
        id="header"
        className="relative flex justify-between items-center px-8 my-2"
      >
        <Typography
          variant="heading"
          as="p"
          className="text-gray800 max-w-[90%] text-[23px]"
        >
          {globalLocalize('confirmAction')}
        </Typography>
        <button
          type="button"
          className={closeButtonClassNames}
          onClick={onCloseClicked}
        >
          <Icon icon="close" />
        </button>
      </div>
      <Divider orientation="horizontal" className="w-full" />
      <div className="p-6 max-h-[80%] flex justify-center items-center">
        <Typography
          as="h3"
          variant="body-large-bold"
          className="text-center text-gray700 text-[18px] w-full"
        >
          {!isLoading && message}
          {isLoading && globalLocalize('loading')}
        </Typography>
      </div>
      <Divider orientation="horizontal" className="w-full" />
      <div
        id="footer"
        className="w-full flex justify-between px-3 lg:px-auto items-center lg:pr-8 py-4"
      >
        <Button
          variant="outlined"
          labelClassName="text-gray500 text-body-medium-bold lg:text-body-large-bold"
          className="text-gray500 px-3 lg:mr-4 lg:px-4 py-2"
          type="button"
          label={globalLocalize('goBack')}
          onClick={onCloseClicked}
        />
        <Button
          variant="primary"
          className="px-3 lg:px-4 py-2"
          loading={isLoading}
          label={globalLocalize('confirm')}
          type="button"
          onClick={onConfirmClicked}
        />
      </div>
    </Dialog>
  );
};

export default ConfirmationDialog;
